import React from "react"

const HospitalPreferenceContext = React.createContext({})

const { Provider, Consumer } = HospitalPreferenceContext

export { Provider, Consumer, HospitalPreferenceContext }
